<template>
    <div class="iFrame">
    <iframe ref="iframeTop" class="dynamic-iframe" :src="iframe1URL" scrolling="no"/>
  </div>
  <div class="iFrame">
    <iframe ref="iframeBottom" class="dynamic-iframe" :src="iframe2URL" scrolling="no"/>
  </div>
  </template>
  
  <script>
  import { mapState, mapGetters } from 'vuex';
  import '../assets/styles/modal.css'
  import '../assets/styles/base.css'
  
  export default {
    name: "WelcomePage",
    data() {
      return {
        bottomURL: "",
        iframe1URL: (window.__APP_CONFIG__?.VUE_APP_IFRAME1_URL || "https://www-vali.lausanne.ch/hors-arbo/smeo-1/contentAutogenerated/autogeneratedContainer/col1/00"),
        iframe2URL: (window.__APP_CONFIG__?.VUE_APP_IFRAME2_URL || "https://www-vali.lausanne.ch/hors-arbo/smeo-2/contentAutogenerated/autogeneratedContainer/col1/00"),
      }
    },
    computed: {
      ...mapState('auth', ['isAuthenticated', 'user']),
      ...mapGetters('referential', ['getMaxLength']),
    },
    mounted() {
      window.addEventListener("message", this.myEventHandler);
      window.addEventListener("resize", this.handleWindowResize);
    },

    unmounted() {
      window.removeEventListener("message", this.myEventHandler);
      window.removeEventListener("resize", this.handleWindowResize);
      clearTimeout(this.resizeTimeout);
    },
    methods:{
      myEventHandler(event) {
        const data = event.data;

        if (!data || data.type !== "iframe-height") return;

        const height = Number(data.height);
        if (!Number.isFinite(height)) return;

        const top = this.$refs.iframeTop;
        const bottom = this.$refs.iframeBottom;

        if (top && top.contentWindow === event.source) {
          top.style.height = height + "px";
          return;
        }

        if (bottom && bottom.contentWindow === event.source) {
          bottom.style.height = height + "px";
          return;
        }
      },
      handleWindowResize() {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
          const top = this.$refs.iframeTop;
          const bottom = this.$refs.iframeBottom;

          if (top) {
          top.style.height = '10px'; 
          //eslint-disable-next-line
          top.src = top.src;
        }
        
        if (bottom) {
          bottom.style.height = '10px';
          //eslint-disable-next-line
          bottom.src = bottom.src;
        }
        }, 300);
      },
    }

  };
  </script>
  
  <style scoped>
  .welcome {
    padding: 20px 0px 10px;
    margin: 10px auto;
    text-align: center;
    border-bottom: #e5e5e54a 1px solid;
  }
  .connect {
    display: flex;
    justify-content: center;
    margin: 20px 0;
  }
  
  .login-section {
    max-width: 450px;
    width: 100%;
  }
  
  .compact-form {
    padding: 14px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(255, 172, 172, 0.5);
    margin-bottom: 16px;
  }
  
  .input-group {
    margin-bottom: 16px;
  }
  
  .input-label {
    font-weight: 600;
    font-size: 0.9rem;
    display: block;
    margin-bottom: 4px;
    color: #2c3e50;
  }
  
  .input-control {
    width: 100%;
    padding: 8px 12px;
    font-size: 0.9rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: rgba(245, 245, 245, 0.031);
  }
  
  .password-wrapper {
    position: relative;
    display: flex;
  }
  
  .password-wrapper .input-control {
    flex: 1;
    padding-right: 40px;
  }
  
  .eye-icon {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  
  .bi {
    font-size: 1rem;
    color: var(--text-color);
    padding: 0 12px;
  }
  
  .form-footer {
    display: flex;
    justify-content: center;
    margin-top: 16px;
  }

  button{
    padding: 1vh 1.75vw;
  }
  
  a {
    color: var(--primary-color);
    text-decoration: none;
    transition: all 0.3s ease;
    margin: 8px 0 0 75px;
    text-align: center;
  }
  
  a:hover {
    color: var(--primary-color);
    text-decoration: underline;
  }

  .register-link {
    text-align: center;
    margin: 16px 75px 0 0;
  }

   .iFrame {
      margin: 0 auto;
    }

    .dynamic-iframe {
      width: 100%;
      border: none;
      display: block;
    }
  </style>